export const url = 'http://abb.notnull.com.ar:5999';
